import {
    IIssueChartDataCreateRequest,
    IssueChartDataAnnotation,
    IssueChartDataArrowAnnotation,
    IssueChartDataCreateRequest,
    IssueChartDataEllipseAnnotation,
    IssueChartDataRectangleAnnotation,
    IssueChartDataTextAnnotation,
    IssueFrequencySpectrumChartDataCreateRequest,
    IssueFrequencySpectrumChartMeta,
    IssueFrequencyWaterfallChartDataCreateRequest,
    IssueFrequencyWaterfallChartMeta,
    IssueStatusType,
    IssueTimeDomainChartDataCreateRequest,
    IssueTimeDomainChartMeta,
    IssueTimeSeriesChartDataCreateRequest,
    IssueTimeSeriesChartMeta,
} from '@kcftech/prometheustypescriptapiclient';
import { IssueChartDataInfo } from 'pages/Desk/issues/chart_data/types';
import { AnnotationConfig } from 'shared/svg_annotations/types';
import { CSSProperties } from 'styled-components';

const normalizeAngle = (deg: number) => {
    const newDeg = deg % 360;

    return newDeg > 0 ? newDeg : newDeg + 360;
};

export const getIssueChartDataAnnotation = (
    annotation: AnnotationConfig
): IssueChartDataAnnotation => {
    switch (annotation.type) {
        case 'arrow':
            return new IssueChartDataArrowAnnotation({
                Color: annotation.color,
                HeadX: annotation.headX,
                HeadY: annotation.headY,
                TailX: annotation.tailX,
                TailY: annotation.tailY,
            });
        case 'ellipse':
            return new IssueChartDataEllipseAnnotation({
                Color: annotation.color,
                X1: annotation.x1,
                Y1: annotation.y1,
                X2: annotation.x2,
                Y2: annotation.y2,
            });
        case 'rectangle':
            return new IssueChartDataRectangleAnnotation({
                Color: annotation.color,
                X1: annotation.x1,
                Y1: annotation.y1,
                X2: annotation.x2,
                Y2: annotation.y2,
            });
        case 'text':
            return new IssueChartDataTextAnnotation({
                Color: annotation.color,
                X: annotation.x,
                Y: annotation.y,
                PinAngle: normalizeAngle(annotation.angleDegrees),
                PinNumber: annotation.number,
                PinTextColor: annotation.textColor,
                Text: annotation.text,
            });
        default:
            throw new Error('Invalid annotation type');
    }
};

export const getChartDataCreateRequest = (
    info: IssueChartDataInfo,
    canSetFaultStatus: boolean
): IssueChartDataCreateRequest => {
    const common: IIssueChartDataCreateRequest = {
        Title: info.title,
        SvgData: info.svgXml,
        ChartAnnotations: info.annotations.map(getIssueChartDataAnnotation),
        FaultStatus: canSetFaultStatus ? info.faultStatus : undefined,
    };

    switch (info.meta.type) {
        case 'frequency-spectrum':
            return new IssueFrequencySpectrumChartDataCreateRequest({
                ...common,
                ChartMeta: new IssueFrequencySpectrumChartMeta(info.meta.meta),
            });
        case 'frequency-waterfall':
            return new IssueFrequencyWaterfallChartDataCreateRequest({
                ...common,
                ChartMeta: new IssueFrequencyWaterfallChartMeta(info.meta.meta),
            });
        case 'time-domain':
            return new IssueTimeDomainChartDataCreateRequest({
                ...common,
                ChartMeta: new IssueTimeDomainChartMeta(info.meta.meta),
            });
        case 'time-series':
            return new IssueTimeSeriesChartDataCreateRequest({
                ...common,
                ChartMeta: new IssueTimeSeriesChartMeta(info.meta.meta),
            });
        default:
            throw new Error('Invalid meta type');
    }
};

export const allowedHealthRangeIssueStatuses = [
    IssueStatusType.New,
    IssueStatusType.Open,
    IssueStatusType.Closed,
];

export const dropdownTriggerStyles: CSSProperties = {
    marginTop: 5,
    borderRadius: 3,
    fontSize: '1.4rem',
};
